import { createMutationAtom } from 'atoms/create-resource-atom';
import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import {
  StructureGridManagementQueryResponse,
  StructureGridResponse,
} from 'types/api-responses';

interface StructureGridQueryParams extends SearchParams {
  sort_by?: 'created_at' | 'updated_at';
  sort_order?: 'desc' | 'asc';
  basin_name?: string;
  geologic_interval?: string;
  owner?: string;
  source?: string;
  validity?: string;
  status?: string;
  date_filter_type?: 'none' | 'created';
  created_at?: {
    start?: string;
    end?: string;
  };
}

export const createStructureGridSearchAtom = (pageSizePreference: number) => {
  const params = new URLSearchParams(window.location.search);

  // Handle sort parameters
  const sortBy =
    (params.get('sort_by') as 'created_at' | 'updated_at') || 'created_at';
  const sortOrder = (params.get('sort_order') as 'desc' | 'asc') || 'desc';

  // Handle filter parameters
  const basinName = params.get('basin_name') || undefined;
  const geologicInterval = params.get('geologic_interval') || undefined;
  const owner = params.get('owner') || undefined;
  const source = params.get('source') || undefined;
  const validity = params.get('validity') || undefined;
  const status = params.get('status') || undefined;
  const dateFilterType =
    (params.get('date_filter_type') as 'none' | 'created') || 'none';
  const startDate = params.get('start_date') || undefined;
  const endDate = params.get('end_date') || undefined;

  return searchAtomPair<
    StructureGridManagementQueryResponse,
    StructureGridQueryParams
  >('structureGrids', {
    page: parseInt(params.get('page') || '1', 10),
    pageSize: pageSizePreference,
    sort_by: sortBy,
    sort_order: sortOrder,
    basin_name: basinName,
    geologic_interval: geologicInterval,
    owner: owner,
    source: source,
    date_filter_type: dateFilterType,
    created_at: {
      start: startDate,
      end: endDate,
    },
    validity: validity,
    status: status,
  });
};

export const updateStructureGridAtom = createMutationAtom<
  StructureGridResponse,
  'editStructureGrid'
>();
